
















import { Component, Prop, Vue } from 'vue-property-decorator'
import TheFooterStore from '../stores/TheFooter'

const component: Object = {
  store: {
    TheFooterStore,
  },
}

@Component(component)

export default class ComponentTheFooter extends Vue {
  stores: any = {
    theFooter: (this.$store as any).TheFooterStore,
  }

  get currentYear(): String {
    const currentDate = new Date()
    return currentDate.getFullYear()
  }

  get show() {
    return this.stores.theFooter.getters.SHOW
  }
}
